export const TAB_ALL_FORECASTS_LINK = 'all'
export const TAB_FAVORITES_LINK = 'favorites'
export const TAB_FOLDER_LINK = 'folder'
